module.exports = __webpack_public_path__ + "img/icon-coupon-orange.8329bd20.svg";